import { Component } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  dashboard: string[] = [
    'slaAlarms',
    'nonSlaAlarms',
    'stats',
    'globalAlarms'
  ];
}
